(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ZhktDrage", [], factory);
	else if(typeof exports === 'object')
		exports["ZhktDrage"] = factory();
	else
		root["ZhktDrage"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "draggable",
  props: {
    mask: {
      type: Boolean,
      default: true
    },
    scale: {
      type: Number,
      default: 1
    },
    resize: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    },
    zIndex: {
      type: [Number, String],
      default: 1
    },
    left: {
      type: Number,
      default: 0
    },
    top: {
      type: Number,
      default: 0
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    }
  },
  data: function data() {
    return {
      ELEMENT: "__",
      MODS: "--",
      baseWidth: 0,
      baseHeight: 0,
      baseLeft: 0,
      baseTop: 0,
      children: {},
      moveActive: false,
      overActive: false,
      rangeActive: false,
      active: false,
      keydown: null,
      rangeList: [{
        classname: "left"
      }, {
        classname: "right"
      }, {
        classname: "top"
      }, {
        classname: "bottom"
      }, {
        classname: "top-left"
      }, {
        classname: "top-right"
      }, {
        classname: "bottom-left"
      }, {
        classname: "bottom-right"
      }]
    };
  },

  computed: {
    scaleVal: function scaleVal() {
      return this.scale;
    },
    styleLineName: function styleLineName() {
      return {
        borderWidth: this.setPx(this.scaleVal)
      };
    },
    styleRangeName: function styleRangeName() {
      var calc = 10 * this.scaleVal;
      return {
        width: this.setPx(calc),
        height: this.setPx(calc)
      };
    },
    styleLabelName: function styleLabelName() {
      return {
        fontSize: this.setPx(18 * this.scaleVal)
      };
    },
    styleName: function styleName() {
      var _this = this;

      return Object.assign(function () {
        if (_this.active) {
          return Object.assign({
            zIndex: 9999
          }, _this.styleLineName);
        }
        return { zIndex: _this.zIndex };
      }(), {
        top: this.setPx(this.baseTop),
        left: this.setPx(this.baseLeft),
        width: this.setPx(this.baseWidth),
        height: this.setPx(this.baseHeight)
      });
    }
  },
  watch: {
    active: function active(val) {
      if (val) {
        this.handleKeydown();
      } else {
        document.onkeydown = this.keydown;
      }
    },
    width: function width(val) {
      this.baseWidth = this.getFixed(val) || this.children.offsetWidth;
    },
    height: function height(val) {
      this.baseHeight = this.getFixed(val) || this.children.offsetHeight;
    },
    left: function left(val) {
      this.baseLeft = this.getFixed(val);
    },
    top: function top(val) {
      this.baseTop = this.getFixed(val);
    },
    baseWidth: function baseWidth(val) {
      this.$refs.wrapper.style.width = this.setPx(val);
      if (this.resize && this.children.style) {
        this.children.style.width = this.setPx(val);
      }
    },
    baseHeight: function baseHeight(val) {
      this.$refs.wrapper.style.height = this.setPx(val);
      if (this.resize && this.children.style) {
        this.children.style.height = this.setPx(val);
      }
    }
  },
  mounted: function mounted() {
    this.init();
  },

  methods: {
    getFixed: function getFixed() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

      return Number(val.toFixed(len));
    },
    getObjType: function getObjType(obj) {
      var toString = Object.prototype.toString;
      var map = {
        "[object Boolean]": "boolean",
        "[object Number]": "number",
        "[object String]": "string",
        "[object Function]": "function",
        "[object Array]": "array",
        "[object Date]": "date",
        "[object RegExp]": "regExp",
        "[object Undefined]": "undefined",
        "[object Null]": "null",
        "[object Object]": "object"
      };
      if (obj instanceof Element) {
        return "element";
      }
      return map[toString.call(obj)];
    },
    deepClone: function deepClone(data) {
      var type = this.getObjType(data);
      var obj;
      if (type === "array") {
        obj = [];
      } else if (type === "object") {
        obj = {};
      } else {
        // 不再具有下一层次
        return data;
      }
      if (type === "array") {
        for (var i = 0, len = data.length; i < len; i++) {
          data[i] = function () {
            if (data[i] === 0) {
              return data[i];
            }
            return data[i];
          }();
          if (data[i]) {
            delete data[i].$parent;
          }
          obj.push(this.deepClone(data[i]));
        }
      } else if (type === "object") {
        for (var key in data) {
          if (data) {
            delete data.$parent;
          }
          obj[key] = this.deepClone(data[key]);
        }
      }
      return obj;
    },
    validatenull: function validatenull(val) {
      // 特殊判断
      if (val && parseInt(val) === 0) return false;
      var list = ["$parent"];
      if (val instanceof Date || typeof val === "boolean" || typeof val === "number") return false;
      if (val instanceof Array) {
        if (val.length === 0) return true;
      } else if (val instanceof Object) {
        val = this.deepClone(val);
        list.forEach(function (ele) {
          delete val[ele];
        });
        for (var o in val) {
          return false;
        }
        return true;
      } else {
        if (val === "null" || val == null || val === "undefined" || val === undefined || val === "") {
          return true;
        }
        return false;
      }
      return false;
    },
    setPx: function setPx(val) {
      var defval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      if ((0, this.validatenull)(val)) val = defval;
      if ((0, this.validatenull)(val)) return "";
      val = val + "";
      if (val.indexOf("%") === -1) {
        val = val + "px";
      }
      return val;
    },
    prefix: function prefix(name, mods) {
      var _this2 = this;

      if (typeof mods === "string") {
        return this.join(name, mods, this.MODS);
      }

      if (Array.isArray(mods)) {
        return mods.map(function (item) {
          return _this2.prefix(name, item);
        });
      }

      var ret = {};
      var that = this;
      Object.keys(mods || {}).forEach(function (key) {
        ret[name + that.MODS + key] = mods[key];
      });
      return ret;
    },
    join: function join(name, el, symbol) {
      return el ? name + symbol + el : name;
    },
    getStyleName: function getStyleName(el, mods) {
      var name = this.$options.name;

      if (el && typeof el !== "string") {
        mods = el;
        el = "";
      }
      el = this.join(name, el, this.ELEMENT);

      return mods ? [el, this.prefix(el, mods)] : el;
    },
    init: function init() {
      this.children = this.$refs.item.firstChild;
      this.baseWidth = this.getFixed(this.width) || this.children.offsetWidth;
      this.baseHeight = this.getFixed(this.height) || this.children.offsetHeight;
      this.baseLeft = this.getFixed(this.left);
      this.baseTop = this.getFixed(this.top);
      this.keydown = document.onkeydown;
    },
    setLeft: function setLeft(left) {
      this.baseLeft = left;
    },
    setTop: function setTop(top) {
      this.baseTop = top;
    },
    getRangeStyle: function getRangeStyle(postion) {
      var _this3 = this;

      var calc = 10 * this.scaleVal / 2;
      var result = {};
      var list = postion.split("-");
      list.forEach(function (ele) {
        result[ele] = _this3.setPx(-calc);
      });
      return result;
    },
    setOverActive: function setOverActive(val) {
      this.overActive = val;
    },
    setActive: function setActive(val) {
      this.active = val;
    },
    rangeMove: function rangeMove(e, position) {
      var _this4 = this;

      if (this.disabled) return;
      //移动的方向
      var x = void 0,
          y = void 0;
      //移动的位置
      var xp = void 0,
          yp = void 0;
      //移动的正负
      var xc = void 0,
          yc = void 0;
      this.rangeActive = true;
      this.handleMouseDown();
      var disX = e.clientX;
      var disY = e.clientY;
      document.onmousemove = function (e) {
        _this4.moveActive = true;
        if (position === "right") {
          x = true;
          y = false;
        } else if (position === "left") {
          x = true;
          xp = true;
          xc = true;
          y = false;
        } else if (position === "top") {
          x = false;
          y = true;
          yp = true;
          yc = true;
        } else if (position === "bottom") {
          x = false;
          y = true;
        } else if (position === "bottom-right") {
          x = true;
          y = true;
        } else if (position === "bottom-left") {
          x = true;
          y = true;
          xp = true;
          xc = true;
        } else if (position === "top-right") {
          x = true;
          y = true;
          yp = true;
          yc = true;
        } else if (position === "top-left") {
          x = true;
          y = true;
          xp = true;
          xc = true;
          yp = true;
          yc = true;
        }
        var left = e.clientX - disX;
        var top = e.clientY - disY;
        disX = e.clientX;
        disY = e.clientY;
        if (x) {
          var calc = left * _this4.step;
          if (xc) calc = -calc;
          if (xp) _this4.baseLeft = _this4.getFixed(_this4.baseLeft - calc);
          _this4.baseWidth = _this4.getFixed(_this4.baseWidth + calc);
        }
        if (y) {
          var _calc = top * _this4.step;
          if (yc) _calc = -_calc;
          if (yp) _this4.baseTop = _this4.getFixed(_this4.baseTop - _calc);
          _this4.baseHeight = _this4.getFixed(_this4.baseHeight + _calc);
        }
      };
      this.handleClear();
    },
    handleOut: function handleOut() {
      this.overActive = false;
      this.$emit("out", {
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop
      });
    },
    handleOver: function handleOver() {
      if (this.disabled) return;
      this.overActive = true;
      this.$emit("over", {
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop
      });
    },
    handleMove: function handleMove(e) {
      var _this5 = this;

      if (this.disabled) return;
      this.active = true;
      this.handleMouseDown();
      var disX = e.clientX;
      var disY = e.clientY;
      document.onmousemove = function (e) {
        var left = e.clientX - disX;
        var top = e.clientY - disY;
        disX = e.clientX;
        disY = e.clientY;
        _this5.baseLeft = _this5.getFixed(_this5.baseLeft + left * _this5.step);
        _this5.baseTop = _this5.getFixed(_this5.baseTop + top * _this5.step);
      };
      this.handleClear();
    },
    handleClear: function handleClear() {
      var _this6 = this;

      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
        _this6.handleMouseUp();
      };
    },
    handleKeydown: function handleKeydown() {
      var _arguments = arguments,
          _this7 = this;

      document.onkeydown = function (event) {
        var e = event || window.event || _arguments.callee.caller.arguments[0];
        var step = 1 * _this7.step;
        if (e && e.keyCode == 38) {
          //上
          _this7.baseTop = _this7.getFixed(_this7.baseTop - step);
        } else if (e && e.keyCode == 37) {
          //左
          _this7.baseLeft = _this7.getFixed(_this7.baseLeft - step);
        } else if (e && e.keyCode == 40) {
          //下
          _this7.baseTop = _this7.getFixed(_this7.baseTop + step);
        } else if (e && e.keyCode == 39) {
          //右
          _this7.baseLeft = _this7.getFixed(_this7.baseLeft + step);
        }
        event.stopPropagation();
        _this7.$emit("blur", {
          width: _this7.baseWidth,
          height: _this7.baseHeight,
          left: _this7.baseLeft,
          top: _this7.baseTop
        });
        _this7.keydown && _this7.keydown(event);
      };
    },
    handleMouseDown: function handleMouseDown(e) {
      this.moveActive = true;
      this.$emit("focus", {
        index: this.index,
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop
      });
    },
    handleMouseUp: function handleMouseUp() {
      this.moveActive = false;
      this.rangeActive = false;
      this.$emit("blur", {
        index: this.index,
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop
      });
    }
  }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drage__ = __webpack_require__(2);
// sumFunction 插件对应组件的名字


// Vue.js 的插件应当有一个公开方法 install 。第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象
// 参考：https://cn.vuejs.org/v2/guide/plugins.html#%E5%BC%80%E5%8F%91%E6%8F%92%E4%BB%B6
// 此处注意，组件需要添加name属性，代表注册的组件名称，也可以修改成其他的
__WEBPACK_IMPORTED_MODULE_0__drage__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__drage__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__drage__["a" /* default */]);
}; //注册组件

// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) {
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__drage__["a" /* default */]);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_drage_vue__ = __webpack_require__(0);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7366db06_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_drage_vue__ = __webpack_require__(9);
function injectStyle (ssrContext) {
  __webpack_require__(3)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7366db06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_drage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7366db06_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_drage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3167cfc6", content, true, {});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".draggable[data-v-7366db06]{padding:10px;position:absolute;cursor:move;-webkit-tap-highlight-color:transparent;user-select:none}.draggable__mask[data-v-7366db06]{width:100%;height:100%;border:0;position:absolute;top:0;right:0;bottom:0;left:0;z-index:1}.draggable--active[data-v-7366db06]{cursor:move;border:1px dashed #09f;background-color:rgba(115,170,229,.5)}.draggable--move[data-v-7366db06]{opacity:.6;background-color:rgba(115,170,229,.5)}.draggable--click[data-v-7366db06]{cursor:pointer}.draggable__line--left[data-v-7366db06]{position:absolute;border-top:1px dashed #09f;width:10000px;height:0;top:0;transform:translateX(-100%)}.draggable__line--top[data-v-7366db06]{position:absolute;border-left:1px dashed #09f;width:0;height:10000px;left:0;transform:translateY(-100%)}.draggable__line--label[data-v-7366db06]{top:-5px;left:-8px;position:absolute;padding:5px;transform:translate(-100%,-100%);color:#09f;font-size:18px;white-space:nowrap;cursor:move}.draggable__range[data-v-7366db06]{position:absolute;width:10px;height:10px;border-radius:100%;z-index:9999;background-color:#09f}.draggable__range--left[data-v-7366db06],.draggable__range--right[data-v-7366db06]{top:50%;transform:translateY(-50%)}.draggable__range--left[data-v-7366db06]:hover,.draggable__range--right[data-v-7366db06]:hover{cursor:ew-resize}.draggable__range--left[data-v-7366db06]{left:-6px}.draggable__range--right[data-v-7366db06]{right:-6px}.draggable__range--bottom[data-v-7366db06],.draggable__range--top[data-v-7366db06]{left:50%;transform:translateX(-50%)}.draggable__range--bottom[data-v-7366db06]:hover,.draggable__range--top[data-v-7366db06]:hover{cursor:ns-resize}.draggable__range--top[data-v-7366db06]{top:-6px}.draggable__range--bottom[data-v-7366db06]{bottom:-6px}.draggable__range--bottom-right[data-v-7366db06]:hover,.draggable__range--top-left[data-v-7366db06]:hover{cursor:nwse-resize}.draggable__range--bottom-left[data-v-7366db06]:hover,.draggable__range--top-right[data-v-7366db06]:hover{cursor:nesw-resize}.draggable__range--top-right[data-v-7366db06]{top:-6px;right:-6px}.draggable__range--top-left[data-v-7366db06]{top:-6px;left:-6px}.draggable__range--bottom-right[data-v-7366db06]{bottom:-6px;right:-6px}.draggable__range--bottom-left[data-v-7366db06]{bottom:-6px;left:-6px}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(7)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getStyleName({
      active: _vm.active || _vm.overActive,
      move: _vm.moveActive,
      click: _vm.disabled
    }),style:(_vm.styleName),on:{"mousedown":function($event){$event.stopPropagation();return _vm.handleMove($event)},"mouseover":function($event){$event.stopPropagation();return _vm.handleOver($event)},"mouseout":function($event){$event.stopPropagation();return _vm.handleOut($event)}}},[_c('div',{ref:"wrapper",class:_vm.getStyleName('wrapper')},[_vm._l((_vm.rangeList),function(item,index){return [(_vm.active)?_c('div',{key:index,class:_vm.getStyleName('range', [item.classname]),style:([_vm.styleRangeName, _vm.getRangeStyle(item.classname)]),on:{"mousedown":function($event){$event.stopPropagation();return _vm.rangeMove($event, item.classname)}}}):_vm._e()]}),_vm._v(" "),_c('div',{ref:"item",class:_vm.getStyleName('item')},[_vm._t("default")],2),_vm._v(" "),(!_vm.disabled && _vm.mask)?_c('div',{class:_vm.getStyleName('mask')}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// drage.js